import Const from 'constants';

const FilterLineupsByCorrelationStackCombinations = {
    filterLineupsByCheckedCorrelationStackCombo(checkedCombo) {
        return (dispatch, getState) => {
            const {combo, isChecked} = checkedCombo;
            const {filterLineupsByCorrelationStackCombinations} = getState();
            const combinations = filterLineupsByCorrelationStackCombinations.getCheckedCombinations();

            const checkedCombinations = Boolean(isChecked)
                ? [...combinations, combo]
                : combinations.filter((checkedCombo) => checkedCombo.getUnitId() !== combo.getUnitId());

            dispatch(this.setLineupsFilterByCheckedCorrelationStackCombinations(checkedCombinations));
        };
    },

    setLineupsFilterByCheckedCorrelationStackCombinations(checkedCombinations) {
        return (dispatch, getState) => {
            const {lineupCorrelationStackCombinationsMap} = getState();

            const lineupIds =
                lineupCorrelationStackCombinationsMap.getLineupIdsByCheckedCombinations(checkedCombinations);

            dispatch({
                type: Const.FILTER_LINEUPS_BY_CORRELATION_STACK_COMBINATIONS_SET_COMBO,
                data: {
                    checkedCombinations,
                    lineupIds,
                },
            });
        };
    },
};

export default FilterLineupsByCorrelationStackCombinations;
